import {
  MAGNOLIA_PATHS,
  PRE_LOGIN_INSTRUCTION_ROUTES,
} from '@/utilities/constants/instructions';
import { InstructionPageProps } from '../InstructionPage';

export const instructionRoutesConfig: InstructionPageProps[] = [
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.NAME_APPLICATION,
    id: 'name-app-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.NAME_APPLICATION,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_REGISTRATION,
    id: 'entity-reg-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.ENTITY_REGISTRATION,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.CESSATION_DISSOLUTION,
    id: 'cessation-dissolution-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.CESSATION_DISSOLUTION,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.STRIKE_OFF,
    id: 'strikeoff-business-entity-instruction-container',
    mgnlPagePath: MAGNOLIA_PATHS.STRIKEOFF_BUSINESS_ENTITY,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.POST_STRIKE_OFF,
    id: 'post-initiation-strikeoff-instruction-container',
    mgnlPagePath: MAGNOLIA_PATHS.POST_INITIATION_STRIKEOFF,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_EDIT_PERSONNEL,
    id: 'edit-position-holder-instruction-container',
    mgnlPagePath: MAGNOLIA_PATHS.UPDATE_PERSONNEL_EDIT_PERSONNEL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL,
    id: 'appoint-withdraw-position-holder-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.REDUCTION_SHARE_CAPITAL,
    id: 'reduction-share-capital-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.REDUCTION_SHARE_CAPITAL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.REGISTRATION_OF_CHARGES,
    id: 'registration-of-charges-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.REGISTRATION_OF_CHARGES,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.COMMON_SHARES,
    id: 'common-shares-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.COMMON_SHARES,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS,
    id: 'file-annual-returns-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.ANNUAL_RETURNS_DECLARATIONS,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT,
    id: 'general-lodgement-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.GENERAL_LODGEMENT,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_RENEWAL,
    id: 'entity-renewal-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.ENTITY_RENEWAL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.OBJ_STRIKING_OFF,
    id: 'obj-striking-off-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.OBJ_STRIKING_OFF,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_QUALIFIED_INDIVIDUAL,
    id: 'register-qualified-individual-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.REGISTER_QUALIFIED_INDIVIDUAL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_QUALIFIED_INDIVIDUAL,
    id: 'renew-qualified-individual-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.RENEW_QUALIFIED_INDIVIDUAL,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_RORC,
    id: 'maintenance-rorc-individual-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.MAINTENANCE_OF_RORC,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_SHAREHOLDER,
    id: 'update-shareholder-individual-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.UPDATE_SHAREHOLDER,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.INITIATION_OF_WINDING_UP,
    id: 'inititation-winding-up-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.INITIATION_OF_WINDING_UP,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME,
    id: 'extension-of-time-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.EXTENSION_OF_TIME,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION,
    id: 'variation-satisfaction-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.VARIATION_SATISFACTION,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_CORPORATE_SERVICE_PROVIDER,
    id: 'register-csp-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.REGISTER_CORPORATE_SERVICE_PROVIDER,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_CSP,
    id: 'renew-csp-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.RENEW_CSP,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.POST_INITIATION_OF_WINDING_UP,
    id: 'post-initiation-winding-up-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.POST_INITIATION_OF_WINDING_UP,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_ENTITY_INFO,
    id: 'update-entity-info-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.UPDATE_ENTITY_INFO,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.FINANCIAL_YEAR_END,
    id: 'fye-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.FINANCIAL_YEAR_END,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.NOTICE_OF_ERROR,
    id: 'noe-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.NOTICE_OF_ERROR,
  },
  {
    path: PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_CSP_CLIENT_LIST,
    id: 'maintenance-of-csp-client-list-instruction',
    mgnlPagePath: MAGNOLIA_PATHS.MAINTENANCE_OF_CSP_CLIENT_LIST,
  },
];
